import { buttonBetText } from 'core/components/bet/ButtonBetText'
import { enableTap } from 'core/handlers/TapHandler'
import { ButtonManager } from 'managers/ButtonManager'
import { signal } from 'services/SignalsService'

export default class BetButton extends PIXI.Sprite{
  constructor(data) {
    super(data.texture)
    this._data = data

    this.x = data.x
    this.y = data.y
    this.name = data.name.split('-')[0]
    this.id = `BET:${this.name}`
    this.state = ''
    this.payload = parseInt(data.name.split('-')[1])

    this.width = this.width / data.whCorrection
    this.height = this.height / data.whCorrection
    this.addChild(buttonBetText({ betName: data.name, buttonWidth: this.width * data.whCorrection, whCorrection: data.whCorrection, textPosY: data.textPosY, textPosX: data.textPosX }))
    this.createSignal()

    enableTap(this, this.tap.bind(this))
  }

  createSignal() {
    const self = this
    self.interactive = true

    const secondTexture = game.getTextureFromAtlases('button-0')
    const firstTexture = game.getTextureFromAtlases('button-1')

    signal.on('MODEL:BET', function () {
      if(self.payload !== game.models.BetModel.getID()) {
        self.texture = secondTexture
      }
      else {
        self.texture = firstTexture
      }
    })
  }

  tap(){
    ButtonManager.dispatch(this.id, this._data.deselect && this.payload === this.state ? '' : this.payload )
  }
}
